import React from 'react';
import { Link } from 'react-router-dom';
import { formatRelativeTime } from '../feedUtils';
import { WhatsNewEntry } from '../../../whatsNew/whatsNew';

interface WhatsNewCardProps {
  entry: WhatsNewEntry;
  onDismiss: (id: string) => void;
}

/** "✨ New in Board Game Stats" card: a shipped feature, among the play events. */
export const WhatsNewCard: React.FC<WhatsNewCardProps> = ({ entry, onDismiss }) => (
  <article
    aria-label={`New in Board Game Stats: ${entry.title}`}
    className="pl-3 pr-1 pt-2 bg-surface rounded-lg border border-edge border-l-4 border-l-primary-500"
  >
    <div className="flex items-baseline gap-2 pr-2">
      <p className="flex-1 min-w-0 text-sm leading-snug">
        <span className="font-semibold text-primary-700">
          <span aria-hidden="true">✨ </span>New
          <span className="sr-only"> in Board Game Stats</span>:
        </span>{' '}
        <span className="font-semibold text-heading">{entry.title}</span>
      </p>
      <span className="flex-shrink-0 text-xs text-muted tabular-nums">{formatRelativeTime(entry.date)}</span>
    </div>
    <p className="pr-2 text-sm text-body leading-snug">{entry.blurb}</p>
    {entry.image && (
      <img src={entry.image} alt="" loading="lazy" className="mt-2 max-h-40 rounded border border-edge" />
    )}
    <div className="flex items-center justify-end -mt-1">
      <button
        type="button"
        data-track="feed_whats_new_dismiss"
        onClick={() => onDismiss(entry.id)}
        className="inline-flex items-center min-h-[44px] px-3 text-sm text-muted hover:text-body"
      >
        Got it
      </button>
      <Link
        to={entry.link}
        data-track="feed_whats_new_try"
        className="inline-flex items-center min-h-[44px] px-3 text-sm font-semibold text-primary-700 hover:text-primary-800"
      >
        Try it →
      </Link>
    </div>
  </article>
);
